import { Input } from "@/components/tailwind-ui/Input";
import { AcceptedEstimate } from "@/components/views/AcceptedEstimate";
import { ApproveCostEstimateTable } from "@/components/views/ApproveCostEstimateTable";
import { useRepairFilter } from "@/hooks/useRepairFilter";
import { NextPage } from "next";
import { useState } from "react";
import CreateCostEstimate from "../../components/CreateCostEstimate";
import RepairTable from "../../components/RepairTable";
import { withApollo } from "../../components/WithApollo";
import Select from "../../components/form/Select";
import { useRepairContext } from "../../contexts/RepairContext";
import { useUserContext } from "../../contexts/UserContext";
import useFormHook from "../../hooks/useForm";

export const InnerProcessingComponent = (props) => {
  const { status, costEstimates } = props;
  const { userData, isAdmin, isColosseumManager } = useUserContext();
  const isRepairOwner = props.user.email === userData.email || (isColosseumManager && userData.managedUsers.length > 0);
  const inTransport = status === "in_transport";
  const costEstimateAvailable = status === "cost_estimate_available";
  const accepted = status === "accepted" || status === "in_repair";

  const RenderCreateCostEstimate = isAdmin && inTransport;
  const ShowCostEstimate = accepted || (!isRepairOwner && costEstimateAvailable);
  const ShowApproveCostEstimate = costEstimateAvailable && isRepairOwner;

  const RegisterFormProps = useFormHook();
  const [temporaryEstimate, setTemporaryEstimate] = useState(costEstimates[0]);
  const [estimateValid, setEstimateValid] = useState(false);
  const { view = "nothing" } = RegisterFormProps.formValues;
  const hideCreate = view !== "nothing" && view !== "create";

  return (
    <div>
      {isAdmin && (
        <div className="flex justify-start">
          <Select
            className="w-1/2"
            options={[
              { label: "Standard", value: "nothing" },
              { label: "Erstellen", value: "create" },
              { label: "Kundenansicht", value: "approve" },
              { label: "Adminansicht", value: "show" },
            ]}
            id="view"
            label="Ansicht wechseln"
            placeholder="Ansicht wechseln"
            disabled={!costEstimates[0] && !estimateValid}
            defaultValue="nothing"
            {...RegisterFormProps}
          />
        </div>
      )}
      {RenderCreateCostEstimate && (
        <CreateCostEstimate
          hidden={hideCreate}
          {...props}
          setTemporaryEstimate={setTemporaryEstimate}
          defaultEstimate={temporaryEstimate}
          setEstimateValid={setEstimateValid}
        />
      )}
      {(view === "nothing" || !isAdmin) && ShowApproveCostEstimate && (
        <ApproveCostEstimateTable
          user={props.user}
          costEstimate={costEstimates[0]}
          repairId={props.id}
          repairNumber={props.repairNumber}
          createdAt={props.createdAt}
        />
      )}
      {view === "approve" && (costEstimateAvailable || RenderCreateCostEstimate) && (
        <ApproveCostEstimateTable
          user={props.user}
          isTemporary={!costEstimateAvailable}
          costEstimate={costEstimateAvailable ? costEstimates[0] : temporaryEstimate}
          repairId={props.id}
          repairNumber={props.repairNumber}
          createdAt={props.createdAt}
        />
      )}
      {view === "nothing" && ShowCostEstimate && (
        <AcceptedEstimate
          costEstimate={costEstimates[0]}
          user={props.user}
          repairId={props.id}
          repairNumber={props.repairNumber}
          createdAt={props.createdAt}
        />
      )}
      {view === "show" && (
        <AcceptedEstimate
          costEstimate={costEstimateAvailable ? costEstimates[0] : temporaryEstimate}
          user={props.user}
          repairId={props.id}
          repairNumber={props.repairNumber}
          createdAt={props.createdAt}
        />
      )}
    </div>
  );
};

const ProcessingRepairs: NextPage = () => {
  const { isAdmin } = useUserContext();
  const { loading, repairs: unfilteredRepairs } = useRepairContext();
  const repairs = unfilteredRepairs.filter((repair) =>
    ["in_transport", "cost_estimate_available", "accepted", "in_repair"].includes(repair.status)
  );

  // const rejectedRepairsWithNoReturn = useMemo(
  //   () => repairs.filter((repair) => repair.status === "rejected" && !repair.returnLabel),
  //   [repairs]
  // );
  const [filteredRepairs, inputProps] = useRepairFilter(repairs);

  return (
    <div>
      {isAdmin && (
        <div className="flex items-end justify-between px-6 mx-auto mb-6">
          <div className="space-x-4"></div>
          <div>
            <div className="w-64">
              <Input label="Suche" {...inputProps}></Input>
            </div>
          </div>
        </div>
      )}
      <RepairTable
        repairs={filteredRepairs}
        loading={loading}
        OpenRowComponent={InnerProcessingComponent}
        paginate={false}
      />
    </div>
  );
};

export default withApollo()(ProcessingRepairs);
